import ComponentStyle from '../ComponentStyle'

export default function ComponentBlocksVideoWithDescription ({ Video, Description, Position, Button }) {
  const getOrder = currentDirection => {
    if (!Position || !Position.Position) return ''

    if (Position.Position === 'Left') return currentDirection === 'Left' ? 'order-1' : 'order-2'

    return currentDirection === 'Left' ? 'order-2' : 'order-1'
  }

  return (
    <div className="col-12">
      <div className="row">
        <div className={`col-12 col-lg-6 ${getOrder('Left')}`}>
          <video
            className="img-fluid w-100"
            width={Video.data.attributes.width}
            height={Video.data.attributes.height}
            controls
          >
            <source src={`${process.env.NEXT_PUBLIC_CMS_URL}${Video.data.attributes.url}`} />
          </video>
        </div>
        <div className={`col-12 col-lg-6 align-self-center mt-4 mt-lg-0 p-md-4 p-lg-5 ${getOrder('Right')}`}>
          <div dangerouslySetInnerHTML={{ __html: Description }}></div>
          {
            Button && (
              <ComponentStyle config={{
                Margin: Button.Margin,
                TextAlignment: Button.TextAlignment,
                Size: Button.Size
              }}
              >
                <a
                  href={Button.Link}
                  className={`btn btn-${Button.Variant}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {Button.Text}
                </a>
              </ComponentStyle>
            )
          }
        </div>
      </div>
    </div>
  )
}
